export const MAIN_HEADER = "Ты сегодня покормил кота?";
export const DEFAULT_CARD_SUBTITLE = "Сказочное заморское яство";
export const HOVER_CARD_SUBTITLE = "Котэ не одобряет?";
